module.exports = __webpack_public_path__ + "img/pulse-iot-center.748ce92f.webp";